/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  Constants  */
const { hasData, getOne } = Response;

class Tenant {
    constructor() {
        this.requests = new Requests();
    }

    cancel = () => {
        this.requests.cancel();
    };

    get = async (p = {}) => {
        const params = p;
        const { size } = params;

        if (!size) {
            params.size = 1;
        }

        try {
            const response = await axios.get('/tenant', {
                cancelToken: this.requests.token(),
                params
            });
            if (!hasData(response)) {
                debug.e('No Tenant found', response);
                return false;
            }

            return getOne(response);
        } catch (e) {
            debug.e('Error getting Tenant', e);
            return false;
        }
    };
}

export default Tenant;
